<template>
<div>
    <v-progress-circular v-show="$apollo.loading" indeterminate :size="50" color="primary"></v-progress-circular>
    
    <v-card v-show="!$apollo.loading">
        <v-card-title primary-title>
            <h3 class="headline mb-0">Sales By Agent</h3>
            
        </v-card-title>
        
        <v-card-text class="px-2">
            <bar-chart :chart-data="dataCollection" :height="200"></bar-chart>
        </v-card-text>
        <v-card-actions>
            <v-btn text color="orange">Chart Options</v-btn>
        </v-card-actions>
    </v-card>
</div>
</template>

<script>

import BarChart from './BarChart';
import {ALL_ITINERARIES_STAFF_QUERY} from '../../../../constants/graphql'
export default {
    name: 'SalesByAgent',
    
    components: {BarChart},

    data () {
        return {
            dataCollection: null,
            itineraries: null
        }
    },

    methods: {
      fillData () {
        let salesByAgent = {};
        for (let itinerary of this.itineraries.edges) {
            let agentName = itinerary.node.agentName;
            if(!salesByAgent[agentName]) {
                salesByAgent[agentName] = 0;
            }
            salesByAgent[agentName] += itinerary.node.totalPrice;
        }
        this.dataCollection = {
                                labels: Object.keys(salesByAgent), 
                                datasets: [{
                                    label: 'Sales',
                                    backgroundColor: '#FF4081',
                                    data: Object.values(salesByAgent)}]
                                };        
      }
    },

    apollo: {
        itineraries: {
          query: ALL_ITINERARIES_STAFF_QUERY,
          variables () {
            return {
              after: this.after,
              filter: this.searchParams
            }
          },
          result({ data, loader, networkStatus }) {
            this.fillData();
            
          }
        }
    }


}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/gt/dashboard/charts/SalesByAgent.vue